import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import '@coreui/coreui/dist/css/coreui.min.css';
// Font pribaleny do aplikace - CSP povoluje jen vlastni origin a nechceme zaviset na Google Fonts.
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import './brand.css';
import { AuthGate } from './auth/AuthGate';
import { AppShell } from './layout/AppShell';
import { MyWorkPage } from './pages/MyWorkPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { SettingsPage } from './pages/SettingsPage';
import { ContractsPage } from './pages/ContractsPage';
import { NewContractPage } from './pages/NewContractPage';
import { GuidePage } from './pages/GuidePage';
import { ContractDetailPage } from './pages/contract/ContractDetailPage';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthGate>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<MyWorkPage />} />
            <Route path="zakazky" element={<ContractsPage />} />
            <Route path="zakazky/nova" element={<NewContractPage />} />
            <Route path="zakazky/:id" element={<ContractDetailPage />} />
            <Route path="nastaveni" element={<SettingsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          {/* Mimo AppShell - papir do dilny, bez menu. */}
          <Route path="zakazky/:id/pruvodka" element={<GuidePage />} />
        </Routes>
      </BrowserRouter>
    </AuthGate>
  </StrictMode>,
);
